import { render, staticRenderFns } from "./SettingsModal.vue?vue&type=template&id=386ee0d1&scoped=true"
import script from "./SettingsModal.vue?vue&type=script&lang=js"
export * from "./SettingsModal.vue?vue&type=script&lang=js"
import style0 from "./SettingsModal.vue?vue&type=style&index=0&id=386ee0d1&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386ee0d1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2718431902/src/v-meetings/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('386ee0d1')) {
      api.createRecord('386ee0d1', component.options)
    } else {
      api.reload('386ee0d1', component.options)
    }
    module.hot.accept("./SettingsModal.vue?vue&type=template&id=386ee0d1&scoped=true", function () {
      api.rerender('386ee0d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/modals/SettingsModal.vue"
export default component.exports